module.exports = __webpack_public_path__ + "img/ms.3a8352bd.svg";